import { render, staticRenderFns } from "./commonClassRankAppraisal.vue?vue&type=template&id=1cf634c0&scoped=true"
import script from "./commonClassRankAppraisal.vue?vue&type=script&lang=js"
export * from "./commonClassRankAppraisal.vue?vue&type=script&lang=js"
import style0 from "./commonClassRankAppraisal.vue?vue&type=style&index=0&id=1cf634c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf634c0",
  null
  
)

export default component.exports